<div class="opciones">
    <div class="col-md-12">
        <p>
            Elija la opción hacia donde quiere ir.
        </p>
    </div>
    <div class="col-md-12">
        <a (click)="solicitud_certificado()">
            <button mat-raised-button color="primary">Solicitud de Certificados</button>
        </a>
    </div>
    <div class="col-md-12" style="padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="sign('seg-certificados')">Seguimiento de Certificados
        </button>
    </div>
    <div class="col-md-12" style="padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="sign('val-certificado')">Validar Certificado Digital
        </button>
    </div>


</div>